/**
 * @generated SignedSource<<be69f61da614e7c66b1dd48e987ec901>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespCondensedContainer_viewer$data = {
  readonly similarItemsGrid?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly serviceId: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsGrid_similarItems">;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespCondensedListedContent_viewer" | "PdpRespDealerChatLoader_viewer" | "PdpRespSimilarItemsGrid_viewer" | "PdpSharedSellerItemsCarousel_viewer">;
  readonly " $fragmentType": "PdpRespCondensedContainer_viewer";
};
export type PdpRespCondensedContainer_viewer$key = {
  readonly " $data"?: PdpRespCondensedContainer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespCondensedContainer_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchPdp"
    },
    {
      "kind": "RootArgument",
      "name": "isClient"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespCondensedContainer_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGrid_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespCondensedListedContent_viewer"
    },
    {
      "condition": "fetchPdp",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedSellerItemsCarousel_viewer"
        },
        {
          "alias": "similarItemsGrid",
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 16
            },
            {
              "kind": "Variable",
              "name": "itemId",
              "variableName": "itemId"
            },
            {
              "kind": "Literal",
              "name": "seller",
              "value": "EXCLUDE"
            }
          ],
          "concreteType": "moreLikeThisItemConnection",
          "kind": "LinkedField",
          "name": "moreLikeThisItem",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "moreLikeThisItemEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Item",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "serviceId",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "PdpRespSimilarItemsGrid_similarItems"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespDealerChatLoader_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "b6d3c3de8f19f3d0ee0b85a4d71c6529";

export default node;
